import UserPageEditor from "./user_page_editor";
import UserAddToCart from "./user_add_to_cart";
import "./management";

$(document).on("turbo:load", function () {
  if (document.querySelectorAll("body.user.pages.edit").length) {
    new UserPageEditor();
  }

  if (document.querySelectorAll(".product-element").length) {
    new UserAddToCart();
  }
});
